import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import EditionsMenu from './EditionsMenu';

defineMessages({
  CLOSE: {
    id: 'CLOSE',
    description: 'Button label to close a modal/dialog.',
    defaultMessage: 'Close',
  },
  CLOSE_EDITIONS_MENU: {
    id: 'CLOSE_EDITIONS_MENU',
    description: 'Button label to editions menu.',
    defaultMessage: 'Close editions menu',
  },
  EDITIONS_MENU_LABEL: {
    id: 'EDITIONS_MENU_LABEL',
    description: 'Button label to change the site edition. E.g. U.K Edition, U.S. Edition, Italia Edizione',
    defaultMessage: '{editionName} Edition',
  },
});

const initialState = {
  isOpen: false,
};

const openState = {
  isOpen: true,
};

class LeftNavTop extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    if (this.state.isOpen) {
      this.setState(initialState);
    } else {
      this.setState(openState);
    }
  }

  render() {
    const { editionInfo } = this.props;
    const { isOpen } = this.state;
    const closeButtonCetDataVars = {
      'data-vars-item-name': 'menu_nav',
      'data-vars-item-type': 'button',
      'data-vars-action-type': 'close',
      'data-vars-action-value': 'menu',
      'data-vars-unit-type': 'nav_bar',
      'data-vars-unit-name': 'site_header',
      'data-vars-type': 'web_content_action',
      'data-vars-subunit-type': 'component',
      'data-vars-subunit-name': 'hamburger_nav',
      'data-vars-position-in-subunit': 0,
    };
    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus, react/no-array-index-key */
    return (
      <div className="left-nav__top">
        <button
          id="left-nav-close"
          aria-label="Close Menu"
          className="left-nav__close first-focusable-element"
          {...closeButtonCetDataVars}
        />
        <button
          className="left-nav__editions-menu__toggle yr-track"
          aria-expanded={isOpen}
          onClick={this.toggle}
          aria-label="Open Editions Menu"
        >
          <FormattedMessage id="EDITIONS_MENU_LABEL" values={{ editionName: editionInfo.name }} />
        </button>
        { isOpen
          ? (
            <div className="left-nav__editions-menu">
              <EditionsMenu editionInfo={editionInfo} modifiers={['leftnav']} />
              <div
                className="left-nav__editions-menu__close yr-track"
                aria-label={<FormattedMessage id="CLOSE_EDITIONS_MENU" />}
                role="button"
                aria-expanded={isOpen}
                onClick={this.toggle}
              >
                <FormattedMessage id="CLOSE" />
              </div>
            </div>
          ) : null}
      </div>
    );
    /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus, react/no-array-index-key */
  }
}

LeftNavTop.propTypes = {
  editionInfo: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    link: PropTypes.string,
  }).isRequired,
};

export default LeftNavTop;
